import { authHeader } from "../../../helpers/authHeader";
import axios from "axios";


export default {
    loadUsers,
    saveUser,
    createUser,
    loadActivities,
    saveActivity,
    createActivity,
    loadPermissions
};


function loadUsers() {
    const requestOptions = {
        headers: Object.assign(authHeader(),{'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*'}),
    };

    return axios.get(process.env.REACT_APP_COORDINATOR_URL+'/api/users',  requestOptions)
        .then(response => {
            return response.data;
        }, handleError);
}

function saveUser(user) {
    const requestOptions = {
        headers: Object.assign(authHeader(),{'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*'}),
    };

    return axios.post(process.env.REACT_APP_COORDINATOR_URL+'/api/users/'+ user.id ,user, requestOptions)
        .then(response => {
            return response.data.data;
        }, handleError);
}

function createUser(user) {

    const requestOptions = {
        headers: Object.assign(authHeader(),{'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*'}),
    };

    return axios.post(process.env.REACT_APP_COORDINATOR_URL+'/api/users',user, requestOptions)
        .then(response => {
            return response.data.data;
        }, handleError);
}


function loadActivities() {
    const requestOptions = {
        headers: Object.assign(authHeader(),{'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*'}),
    };

    return axios.get(process.env.REACT_APP_COORDINATOR_URL+'/api/activity',  requestOptions)
        .then(response => {
            return response.data.data;
        }, handleError);
}

function loadPermissions() {
    const requestOptions = {
        headers: Object.assign(authHeader(), {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        }),
    };

    return axios.get(process.env.REACT_APP_COORDINATOR_URL+"/api/permissions", requestOptions)
        .then(response => {
            return response.data.data;
        }, handleError);
}

function saveActivity(activity) {
    const requestOptions = {
        headers: Object.assign(authHeader(),{'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*'}),
    };

    return axios.post(process.env.REACT_APP_COORDINATOR_URL+'/api/activity/'+ activity.id ,activity, requestOptions)
        .then(response => {
            return response.data.data;
        }, handleError);
}

function createActivity(activity) {

    const requestOptions = {
        headers: Object.assign(authHeader(),{'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*'}),
    };

    return axios.post(process.env.REACT_APP_COORDINATOR_URL+'/api/activity',activity, requestOptions)
        .then(response => {
            return response.data.data;
        }, handleError);
}


function handleError(error) {

    if (error.response && !(error.response.status >= 200 && error.response.status < 300)) {
        return Promise.reject(error.response.status);
    }

    return Promise.reject(500);

}



// WEBPACK FOOTER //
// ./src/scenes/Admin/reducer/api.js